import { descriptorsFactory } from '../../utils/filters';
import { ECompletionYearType, CURRENT_YEAR } from '../avaliableYears';

const createDescriptor = descriptorsFactory({ name: 'ConstructionStatus', clear: [] });

export const constructionStatusDescriptors = createDescriptor(
  {
    form: [
      {
        key: 'is_finished',
        type: 'term',
        value: true,
      },
    ],
    label: 'Дом сдан',
    state: String(ECompletionYearType.HandedOver),
  },
  {
    form: [{ key: 'year', type: 'terms', value: [CURRENT_YEAR + ECompletionYearType.CurrentYear] }],
    label: `${CURRENT_YEAR}`,
    state: String(ECompletionYearType.CurrentYear),
  },
  {
    form: [{ key: 'year', type: 'terms', value: [CURRENT_YEAR + ECompletionYearType.InOneYear] }],
    label: `${CURRENT_YEAR + 1}`,
    state: String(ECompletionYearType.InOneYear),
  },
  {
    form: [{ key: 'year', type: 'terms', value: [CURRENT_YEAR + ECompletionYearType.InTwoYears] }],
    label: `${CURRENT_YEAR + 2}`,
    state: String(ECompletionYearType.InTwoYears),
  },
  {
    form: [{ key: 'year', type: 'terms', value: [CURRENT_YEAR + ECompletionYearType.InThreeYears] }],
    label: `${CURRENT_YEAR + 3}`,
    state: String(ECompletionYearType.InThreeYears),
  },
  {
    form: [{ key: 'yeargte', type: 'term', value: CURRENT_YEAR + ECompletionYearType.Later }],
    label: `${CURRENT_YEAR + 4} и позже`,
    state: String(ECompletionYearType.Later),
  },
);
